import { useEffect, useRef, useState } from "react";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function UserMaterialInOutReport (props){

    const view = "UserMaterialInOutReport";

    const { startDate, endDate, onSearchInitialized, onFilterInitialized, apiInitialized } = props;
    const [ api, setApi ] = useState ( null );

    // 검색하면 목록이 새 api 를 넘긴다 — 그때 다시 읽으면 검색 결과(빈 목록의 「데이터가 없습니다」 알림)를 덮으므로 기간이 바뀐 때만 다시 읽는다
    const refreshedRange = useRef ();

    useEffect ( () => {

        const range = `${startDate}~${endDate}`;

        if ( startDate && endDate && api && refreshedRange.current !== range ) {

            // 처음 읽기는 그대로, 사용자가 기간(전일 등)을 바꾼 다시 읽기는 비면 「데이터가 없습니다」를 알린다
            if ( refreshedRange.current ) {

                api.search ();

            } else {

                api.refresh ();

            }

            refreshedRange.current = range;

        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ api, startDate, endDate ] );

    const onModifyUrl = ( url ) => {

        let newUrl = `${url}/${startDate.getFullYear()}/${startDate.getMonth()+1}/${startDate.getDate()}/${endDate.getFullYear()}/${endDate.getMonth()+1}/${endDate.getDate()}`        

        return newUrl;

    };

    const onApiInitialized = ( api ) => {
        
        if(apiInitialized) {
            apiInitialized(api)
        } 

        setApi ( api );

    };

    const onGridInitialized = ( grid ) => {
        grid.allowSorting = false;
    };

    return (
    
        <BasicCrudScreenType
            id="UserMaterialInOutReport"
            noHeader
            view={view}
            viewSchemaUrl={`/api/UserMaterialInOutReportSchema/${startDate.getFullYear()}/${startDate.getMonth()+1}/${startDate.getDate()}/${endDate.getFullYear()}/${endDate.getMonth()+1}/${endDate.getDate()}`}
            onModifyViewUrl={onModifyUrl}
            onApiInitialized={onApiInitialized}
            onSearchInitialized={onSearchInitialized}
            onFilterInitialized={onFilterInitialized}            
            onInitialized={onGridInitialized}
        />

    );

}
export default UserMaterialInOutReport;